export default {
  computed: {
    pageBgStyles: function () {
      return {
        background:
          'linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.4)), url("' +
          this.image +
          '")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/page-bg-styles.js